// extracted by mini-css-extract-plugin
export default {"linkButton":"LinkButton_linkButton__psh5I","ok":"LinkButton_ok__SDIE5","caution":"LinkButton_caution__uAvZm","danger":"LinkButton_danger__Nc1de"};